import React, { Component } from "react";
import styled from "styled-components";

import { ds } from "js/core/models/dataService";
import HoldButton from "js/editor/components/HoldButton";
import { SlideLockType } from "common/constants";
import PresentationEditorController from "js/editor/PresentationEditor/PresentationEditorController";
import { FlexSpacer, Gap30 } from "js/react/components/Gap";
import { stopPropagation } from "js/core/utilities/stopPropagation";
import { Icon } from "../../../Components/Icon";
import { themeColors } from "../../../react/sharedStyles";

const HiddenControls = styled.div`
    transition: 250ms;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    opacity: 0;
`;

const Container = styled.div.attrs(({ visible }) => ({
    style: {
        opacity: visible ? 1 : 0
    }
}))`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    
    
    label {
        color: white;
        text-transform: uppercase;
        font-size: 10px;
    }
    
    label.always-visible {
        opacity: 1;
    }

    &:hover {
        
        ${HiddenControls} {
            opacity: 1;

            label {
                opacity: 1;
            }
        }
    }
`;

const Spacer = styled.div`
    flex-shrink: 0;
    height: calc(50% - 15px);
`;

const AddSlideButton = styled.div`
    cursor: pointer;
    .bai-icon {
        color: #fff !important;
        font-size: 40px;
        filter: none;
        font-variation-settings: "FILL" 0, "wght" 300, "GRAD" 0, "opsz" 2;
    }
    
    label {
        color: white;
    }
    
    &:hover {
        &&& {
            .bai-icon {
                color: ${themeColors.ui_blue} !important;
                font-variation-settings: "FILL" 1, "wght" 300, "GRAD" 0, "opsz" 2;
            }
        }
    }
`;

const ActionButton = styled.div`
    cursor: pointer;
    .bai-icon {
        color: #fff !important;
        font-size: 22px;
        filter: none;
        font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 2;
    }
    &:hover {
        &&& {
            .bai-icon {
                color: ${themeColors.ui_blue} !important;
            }
        }
    }
`;

class SlideActions extends Component {
    state = {
        isDeleteDisabled: false,
        isMoreOptionsDisabled: false,
        isMenuOpen: false
    }

    onLockSlideChange = model => {
        if (model.attributes.lockState[SlideLockType.COLLABORATION]) {
            this.setState({
                isDeleteDisabled: true,
                isMoreOptionsDisabled: true
            });
            return;
        } else {
            this.setState({
                isDeleteDisabled: false,
                isMoreOptionsDisabled: false
            });
        }

        const orgOrTeamMember = (model.attributes.lockState[SlideLockType.ORG] || model.attributes.lockState[SlideLockType.TEAM_MEMBER]) && !ds.selection.slide.isLibrarySlideInCurrentUserOrg();

        this.setState({ isDeleteDisabled: orgOrTeamMember });
    }

    setMenuOpen = value => this.setState({ isMenuOpen: value })

    render() {
        const { currentSlide, showCanvasControls, currentSlideLockOwner, uiTheme } = this.props;
        const { isMenuOpen, isDeleteDisabled } = this.state;
        const deleteAction = currentSlide.isLibrarySlide() ? "Remove" : "Delete";

        return (
            <Container visible={showCanvasControls} className="slide-actions">
                <Spacer />
                <AddSlideButton id="add-slide-button" onMouseDown={stopPropagation(() => PresentationEditorController.showAddSlideDialog())}>
                    <Icon>add_circle</Icon>
                    <label>Add Slide</label>
                </AddSlideButton>

                <Gap30 />
                <HiddenControls>
                    <ActionButton data-test-id="duplicate-slide" onMouseDown={stopPropagation(() => PresentationEditorController.duplicateSlide())}>
                        <Icon>content_copy</Icon>
                        <label>Duplicate</label>
                    </ActionButton>

                    {/*<OtherMenuItems data-test-id="duplicate-slide" onMouseDown={stopPropagation(() => PresentationEditorController.duplicateSlide())} >*/}
                    {/*    <Icon white fill>content_copy</Icon>*/}
                    {/*    <label>Duplicate</label>*/}
                    {/*</OtherMenuItems>*/}
                    {/*<Gap30 />*/}
                    {/*<MoreButton disabled={currentSlideLockOwner ? true : false} $menuIsOpen={isMenuOpen}>*/}
                    {/*    <SlideActionsMenu*/}
                    {/*        disabled={currentSlideLockOwner}*/}
                    {/*        position="above"*/}
                    {/*        onShow={() => {*/}
                    {/*            // To make sure if we select an item from the menu, the selection will be cleared*/}
                    {/*            PresentationEditorController.selectionLayerController.setSelectedElements([]);*/}
                    {/*            this.setMenuOpen(true);*/}
                    {/*        }}*/}
                    {/*        onClose={() => this.setMenuOpen(false)}*/}
                    {/*        setGap={false}*/}
                    {/*        label="More"*/}
                    {/*        icon="more_horiz" />*/}
                    {/*</MoreButton>*/}
                    <FlexSpacer />
                    <HoldButton
                        icon="delete"
                        disabled={isDeleteDisabled || currentSlideLockOwner ? true : false}
                        label={deleteAction}
                        holdLabel={`Hold to ${deleteAction}`}
                        callback={() => PresentationEditorController.deleteSlide()}
                    />
                </HiddenControls>
            </Container>
        );
    }
}

export default PresentationEditorController.withState(SlideActions);
